export default {
  title: '会员装修',
  previewTitle: '会员中心',
  pageSetting: '页面设置',
  pageTitle: '页面标题',
  pageTitlePlaceholder: '请输入页面标题',
  defaultPageTitle: '个人中心',
  modules: '功能模块',
  template: '页面模板',
  templateType: '模板类型',
  bgColor: '背景颜色',
  moduleList: '模块列表',
  moduleConfig: '模块配置',
  editText: '编辑文字',
  editTextTitle: '编辑文字',
  templateGoldBlack: '黑金模板',
  templateGoldWhite: '白金模板',
  useDefaultIcon: '使用默认图标',
  addNav: '新增导航',
  navNamePlaceholder: '请输入导航名称',
  navLinkPlaceholder: '请输入跳转链接',
  memberCenterLink: '会员中心地址',
  copyLinkTitle: '复制链接',
  copyAddress: '复制地址',
  copy: '复制',
  copySuccess: '复制成功',
  scanToPreview: '扫一扫立即预览',
  linkTipH5: '此链接适用于H5环境',
  syncConfig: '同步配置',
  syncConfigTitle: '同步配置',
  syncConfigDesc: '将当前语言（{lang}）的配置同步到以下语言：',
  syncConfigSuccess: '同步成功',
  moduleNames: {
    MemberInfo: '会员信息',
    NavBar: '导航栏',
    PointsRedPacket: '积分与红包',
    TabBar: '底部导航',
  },
  labelName: {
    levelName: '钻石会员',
    progressLabel: '距离升级',
    progressUnit: '点成长值',
    benefitsText: '会员权益',
    pointsTitle: '我的积分',
    pointsRule: '兑换规则',
    pointsExchange: '积分兑换',
    redpacketTitle: '我的红包',
    redpacketRule: '兑换规则',
    redpacketExchange: '红包兑换',
  },
  formLabel: {
    memberLevel: '会员等级',
    memberBenefits: '会员权益',
    pointsModule: '积分模块',
    points: '积分',
    rule: '规则',
    pointsExchange: '积分兑换',
    redpacketModule: '红包模块',
    redpacket: '红包',
    redpacketExchange: '红包兑换',
  },
};